<template>
  <div class="container">
    <div>
    <Navbar @toggleMenu="toggleMenu" />
    <Menu @closeMenu="closeMenu" :compName="compName" v-if = "showMenu"/>
    <StatusbarPassword :user="user"/>
    </div>
    <div class="body">
      <div class="change-passwort-div" >
        <div v-if="error" class="error">{{error}}</div>
        <label>Aktuelles Passwort</label>
        <input v-if="!showPwd" v-model="currentPwd" type="password" />
        <input v-if="showPwd" v-model="currentPwd" type="text" />
        <label>Neues Passwort</label>
        <input v-if="!showPwd" v-model="newPwd" type="password" />
        <input v-if="showPwd" v-model="newPwd" type="text" />
        <label>Neues Passwort wiederholen</label>
        <input v-if="!showPwd" v-model="newPwd2" type="password" />
        <input v-if="showPwd" v-model="newPwd2" type="text" />
        <div class="input-line">
          <input v-model="showPwd" type="checkbox">
          <label >Passwort anzeigen</label>
        </div>   
      </div>

    </div>
    <ActionPanelChangePwd @changePassword ="changePassword"/>
  </div>
</template>

<script>
import Navbar from "../components/Navbar.vue"
import Menu from "../components/Menu.vue"
import StatusbarPassword from "../components/StatusbarPassword.vue"
import ActionPanelChangePwd from "../components/ActionPanelChangePwd.vue"
import { computed, ref } from 'vue'
import {useStore} from 'vuex'
import { useRouter } from 'vue-router';



export default {
  name: "Home",
  components: { Navbar, Menu, StatusbarPassword, ActionPanelChangePwd },
  setup() {
    const compName = 'ChangePassword'
    const showMenu = ref (false)
    const showPwd = ref(true)
    const error = ref()
    const store = useStore()
    const router = useRouter()
    const currentPwd = ref()
    const newPwd = ref()
    const newPwd2 = ref()
    const user = computed(()=> store.state.user)

    const init = async() => {
      try {
        await store.dispatch('init')
      } catch (err) {
        console.log(err.message)
        if (err.message==="Request failed with status code 403") {
          router.push({ name: "Login" });          
        } else if (err.message==="Network Error") {
          error.value = "Keine Verbindung zum Server. Bitte kontrolliere, ob du deine mobilen Daten eingeschaltet hast."
        }

      }
    }

    const toggleMenu = () => {
      showMenu.value = !showMenu.value
    }

    const closeMenu = () => {
        showMenu.value = false
    }


    const changePassword = async () => {
      if (newPwd.value === newPwd2.value) {
      try {
        const changeCredentials ={
          email: user.value.email,
          currentPassword: currentPwd.value,
          newPassword: newPwd.value,
        }
        await store.dispatch("changePassword", changeCredentials);
        router.push({ name: "Home" });
      } catch (err) {
        console.log(err.message);
        if (err.message==="Request failed with status code 403") {
          error.value = "Email oder Passwort falsch! Bitte korrigiere deine Eingaben."
        } else if (err.message==="Network Error") {
          error.value = "Keine Verbindung zum Server. Bitte kontrolliere, ob du deine mobilen Daten eingeschaltet hast."
        }
      } } else {
        error.value = 'Die Wiederholung des neuen Passworts weicht von dem neuen Passwort ab.'     
      }
    };



    init()
    return {user, compName, showMenu, showPwd, error, currentPwd, newPwd, newPwd2, toggleMenu, closeMenu, changePassword}
  }
}
</script>

<style scoped>
  .container {
  height: 100svh;
  width: 100vw;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 115px 1fr 80px;
}

.body {
  overflow-y: scroll;
}

.change-passwort-div {
  width: 80%;
  margin: 0px auto;
  background: white;
  text-align: left;
  padding: 10px;
  border-radius: 15px;
  box-sizing: border-box;
}

.formlabel {
  margin: 0;
}

label {
  display: inline-block;
  margin: 20px 0 10px;
  font-size: 16px;
  -webkit-text-size-adjust: none; /* Disable text size adjustment for WebKit browsers */
  -moz-text-size-adjust: none; /* Disable text size adjustment for Mozilla browsers */
  -ms-text-size-adjust: none; /* Disable text size adjustment for Microsoft browsers */
  text-size-adjust: none; /* Disable text size adjustment for other browsers */
}

input {
  font-size: 16px;
  -webkit-text-size-adjust: none; /* Disable text size adjustment for WebKit browsers */
  -moz-text-size-adjust: none; /* Disable text size adjustment for Mozilla browsers */
  -ms-text-size-adjust: none; /* Disable text size adjustment for Microsoft browsers */
  text-size-adjust: none; /* Disable text size adjustment for other browsers */

  display: block;
  padding: 10px 15px;
  width: 100%;
  box-sizing: border-box;
  border: none;
  border-radius: 20px;
  background-color: #f2f2f2;
}

input[type="checkbox"]{
    display:inline-block;
    width: 20px;
    margin: 0 10px 0 0;
    position: relativ;
    top: 2px;
}

.login {
  background-color: crimson;
  color:white;
  margin: 30px 0;
  font-size: 18px;
}

.logo {
  width: 100px;
  height: 100px;
  margin: 10px auto;
 
}

.error {
  background-color:#f594a7;
  padding: 15px;
  border-radius: 20px;
  font-size: 18px;
}


</style>